const Shader_LoaderCurtain = {
    vert: `
    uniform mat4 matrix_viewProjection;
    uniform mat4 matrix_model;
    
    // Additional inputs
    attribute vec3 vertex_position;
    attribute vec2 vertex_texCoord0;
    
    // Additional shader outputs
    varying vec2 vUv0;
    
    void main(void) {
        // UV is simply passed along as varying
        vUv0 = vertex_texCoord0;
    
        // Position for screen-space
        gl_Position = matrix_model * vec4(vertex_position, 1.0);
        gl_Position.zw = vec2(0.0, 1.0);
    }`,
    frag: `
    precision mediump float;

    
    // Additional varying from vertex shader
    varying vec2 vUv0;
    
    uniform float wipe;
    uniform vec3 col;
    uniform float soften;
    uniform float opacity;
    uniform float vertWipe;

    
    float circle(in vec2 _st, in float _radius){
        vec2 dist = _st-vec2(0.5);
        float adjRad = _radius - soften;
        return 1.-smoothstep(adjRad-soften,
                             adjRad+soften,
                             dot(dist,dist)*2.0);
    }

    void main(){
        vec2 uv = vUv0 - vec2(0.5,0.5);
        float wipeStrength = 1.0-circle(uv+vec2(0.5,0.5), wipe*2.0);
        wipeStrength*= step(vertWipe,uv.y+0.5);
        gl_FragColor=vec4(col, wipeStrength * opacity);
    }


    `
}
export { Shader_LoaderCurtain };